import { render } from "./EditProductImportHistory.vue?vue&type=template&id=5ca1a0a5"
import script from "./EditProductImportHistory.vue?vue&type=script&lang=js"
export * from "./EditProductImportHistory.vue?vue&type=script&lang=js"

import "./EditProductImportHistory.vue?vue&type=style&index=0&id=5ca1a0a5&lang=css"

import exportComponent from "/Users/vinit.kariatukaran/hofmp-hp/hofmp/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__